export default __webpack_public_path__ + "static/media/pink-bg.9dfa7306.png";